import {Grid, MenuIcon, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import * as classes from './DraggableRouteItem.classes'
import type {Props} from './types'

export const DraggableRouteItem = React.memo<Props>(function DraggableRouteItem(props) {
  const {index, address, phone, person, isDragging} = props
  const caption = [phone, person].filter(Boolean).join(', ')

  return (
    <Grid
      alignItems="center"
      className={clsx(classes.item, !isDragging && classes.dividerBottom)}
      justify="flex-start"
      wrap="nowrap"
      container
    >
      <Grid item>
        <div className={clsx(classes.icon, index === 0 && classes.iconRed)}>{index + 1}</div>
      </Grid>
      <Grid direction="column" size="xs" container item>
        <Grid item>
          <Typography thickness="medium" variant="body2">
            {address}
          </Typography>
        </Grid>
        {Boolean(caption) && (
          <Grid item>
            <Typography color="minor" variant="caption1">
              {caption}
            </Typography>
          </Grid>
        )}
      </Grid>
      {index !== 0 && (
        <Grid className={classes.justifyEnd} item>
          <MenuIcon data-e2e={`address-${index}`} />
        </Grid>
      )}
    </Grid>
  )
})
